import axios from 'axios'
import { API_URL, DATA_TYPE_DESIGN } from '../constants';

import DataUtil from '../utilities/DataUtil'

const WORKORDERS_API_URL = `${API_URL}/workOrders`;
const USER_TOKEN = 'token';
const USER_ROLES = 'roles';
const USER_NAME = 'username';
// const USER_ID = 'userId';

class WorkOrderDataService {

    retrieveAllWorkOrders() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findAll`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersByStatus(status) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findByStatus/${status}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countByStatus(status) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/countByStatus/${status}`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            // sessionStorage.removeItem(USER_TOKEN);
            // sessionStorage.removeItem(USER_ROLES);
            // sessionStorage.removeItem(USER_NAME);
            // sessionStorage.clear();
        });
    }

    countByStatusKcs(status, hoanthanh) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/countByStatusKcs/${status}?hoanthanh=${hoanthanh}`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            // sessionStorage.removeItem(USER_TOKEN);
            // sessionStorage.removeItem(USER_ROLES);
            // sessionStorage.removeItem(USER_NAME);
            // sessionStorage.clear();
        });
    }

    countByLenDaStatus(status, statusName) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countByLenDaStatus`, { status: status, statusName: statusName }, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
        });
    }

    countByStatusAndErrorCode(status, errorCode) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/countByStatusAndErrorCode/${status}?errorCode=${errorCode}`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
        });
    }

    countForProduction(countReq) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countForProduction/`, countReq, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            // sessionStorage.removeItem(USER_TOKEN);
            // sessionStorage.removeItem(USER_ROLES);
            // sessionStorage.removeItem(USER_NAME);
            // sessionStorage.clear();
        });
    }

    countByWorker(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countByWorker/`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersByStatusList(statusList) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findByStatusList/`, statusList,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersByStatusAndWorker(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findWorkOrderBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersByStatusAndUser(status, userId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findByStatusAndUser/${status}/${userId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersByUser(userId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findByUser/${userId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersByOrderId(orderId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findByOrderId/${orderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }


    retrieveWorkOrdersByOrderIds(orderIds) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findByOrderIds/`, orderIds,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveById(id) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findById/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveByNo(no) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findByNo?no=${no}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    scanByNo(no) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/scan`, { woNo: no },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return "Error";
        });
    }

    scanByNoAndShipCode(no, shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/scan`, { woNo: no, shipCode: shipCode },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return "Error";
        });
    }

    uploadQualityReport(files, info) {
        let formData = new FormData();
        if (files !== undefined){
            for (var i = 0; i < files.length; i++) {
                formData.append('file', files[i]);
            }
        } else {
            formData.append('file', undefined);
        }

        formData.append('info', JSON.stringify(info));

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/saveQualityReport`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    scanByPCode(pcode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/scanByPCode`, { pcode: pcode },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveSiblingOfWorkOrder(no) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findSibling`, { woNo: no },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadAdditions(files, workOrderId) {
        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/uploadAdditionFiles/${workOrderId}/INFO`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveAdditionsOfWorkOrder(workOrderId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findAdditionByWorkOrderId/${workOrderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        });
    }

    retrieveImagesOfWorkOrder(workOrderId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findImagesByWorkOrderId/${workOrderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadAdditionFiles(files, workOrderId) {
        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/uploadAdditionFiles/${workOrderId}/DESIGN`, formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadImageFiles(files, workOrderId, imageType) {
        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/uploadImageFiles/${workOrderId}/DESIGN/${imageType}`,
            formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    uploadImages(files) {
        let formData = new FormData();
        for (var i = 0; i < files.length; i++) {
            formData.append('file', files[i]);
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/uploadImages`,
            formData,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateWorkOrder(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${WORKORDERS_API_URL}/update/`, workOrder,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    cloneWorkOrder(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/clone/`, workOrder,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateStatusOfWorkOrder(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${WORKORDERS_API_URL}/updateStatusOfWorkOrder/${workOrder.id}`, workOrder,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    printWorkOrder(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/print`, workOrder,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateNoteOfWorkOrder(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateNoteOfWorkOrder`, { id: workOrder.id, note: workOrder.notesFromDesigner },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    //

    shipWorkOrder(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${WORKORDERS_API_URL}/shipOrder/${workOrder.id}`, workOrder,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    printBarcode(workOrder, printConfig) {
        const printUrl = printConfig.url;
        let username = printConfig.username;
        let password = printConfig.pwd;
        const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

        let code = "";
        if (workOrder.shipTo !== null && workOrder.shipTo !== undefined && workOrder.shipTo.length > 0) {
            code = workOrder.shipTo.substring(0, 1);
            if (code === 'Ú'){
                code = 'U';
            }
        }

        let print_data = {
            "PrintBTWAction": {
                "DocumentFile": printConfig.documentFile,
                "Printer": printConfig.printer,
                "PrintToFileFolder": printConfig.printToFileFolder,
                "PrintToFileFileName": printConfig.printToFileName,
                "SaveAfterPrint": printConfig.saveAfterPrint,
                "NamedDataSources": {
                    "orderid": workOrder.orderNo,
                    "prono": workOrder.fullPCode,
                    "model": workOrder.designModel === null || workOrder.designModel === undefined? "" : workOrder.designModel,
                    "qty": workOrder.qty,
                    "size": workOrder.lengthSize === null || workOrder.lengthSize === undefined? "" : workOrder.lengthSize,
                    "weight": workOrder.kl,
                    "code": code,
                    "barcodeid": workOrder.workOrderNo,
                    "thiepid": workOrder.weightOZ
                }
            }
        }

        return axios.post(printUrl, print_data,
           { headers: {'Content-Type': 'application/json','Authorization': `Basic ${base64encodedData}`}}
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeShippingGhiChu(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateShippingNoteOfWorkOrder/`, { id: workOrder.id, note: workOrder.shippingGhiChu },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeShipCode(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateShipCodeOfWorkOrder/`, { id: workOrder.id, shipCode: workOrder.shipCode, shipAt: workOrder.shipDate },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeCsReview(id, csReview) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateCSReview/`, { id: id, csReview: csReview },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    downloadAddition(additionId, contentType) {
        const token = sessionStorage.getItem('token');
        //alert(contentType);
        if (contentType === "application/pdf" || contentType === 'image/webp') {
            return axios.get(`${WORKORDERS_API_URL}/findAdditionById/${additionId}`,
                {
                    responseType: 'arraybuffer',
                    headers: { 'Authorization': `Bearer ${token}` }
                }
            ).then(response => {
                var binary = null;
                binary = response.data;
                const file = new Blob(
                    [binary],
                    { type: contentType }
                );

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            })
                .catch(error => {
                    console.log(error);
                });
        }

        return axios.get(`${WORKORDERS_API_URL}/findAdditionById/${additionId}`,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            var binary = null;
            if (contentType === "text/plain") {
                binary = response.data;
            }
            else {
                binary = DataUtil.fixBinary(atob(response.data));
            }

            const file = new Blob(
                [binary],
                { type: contentType }
            );

            const fileURL = URL.createObjectURL(file);
            window.open(fileURL);
        })
            .catch(error => {
                console.log(error);
            });
    }

    deleteAddition(additionId) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${WORKORDERS_API_URL}/deleteAdditionById/${additionId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteImage(imageId) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${WORKORDERS_API_URL}/deleteImageById/${imageId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteCloneWorkOrder(workOrderId) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${WORKORDERS_API_URL}/${workOrderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    getDeadlineInfo(workOrder) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/getDeadlineInfo`, workOrder,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    initializeSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus, changed, full, pcode, shipCode, workerName, personalization, pageSize, page, includeImage, sku, onlyUrgent, fromDeadlineDate) {
        if (status === undefined || status === null) {
            status = "all";
        }

        if (country === undefined || country === null) {
            country = "all";
        }

        if (customer === undefined || customer === null) {
            customer = "";
        }

        if (orderNo === undefined || orderNo === null) {
            orderNo = "";
        }

        if (changed === undefined || changed === null) {
            changed = 0;
        }

        if (full === undefined || full === null) {
            full = 0
        }

        if (workerName === null || workerName === undefined) {
            workerName = ""
        }

        if (personalization === null || personalization === undefined) {
            personalization = ""
        }

        if (includeImage === 0) {
            includeImage = 0;
        } else {
            includeImage = 1;
        }

        var info = {
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            country: country,
            customer: customer,
            orderNo: orderNo,
            woStatus: woStatus,
            changed: changed,
            isFull: full,
            pcode: pcode,
            shipCode: shipCode,
            workerName: workerName,
            personalization: personalization,
            pageSize: pageSize,
            page: page,
            dataType: DATA_TYPE_DESIGN,
            sortBy: 'orderDate',
            includeImage: includeImage,
            sku: sku,
            pcode: pcode,
            severity: onlyUrgent,
            fromDeadlineDate: fromDeadlineDate
        };
        // console.log("Search info", info)
        return info;
    }

    initializeSearchInfo2(fromDate, toDate, status, country, customer, orderNo, woStatus, changed, full, pcode, shipCode, workerName, personalization, pageSize, page, includeImage, sku, onlyUrgent, fromDeadlineDate, donMua, hanGiaoMua) {
        if (status === undefined || status === null) {
            status = "all";
        }

        if (country === undefined || country === null) {
            country = "all";
        }

        if (customer === undefined || customer === null) {
            customer = "";
        }

        if (orderNo === undefined || orderNo === null) {
            orderNo = "";
        }

        if (changed === undefined || changed === null) {
            changed = 0;
        }

        if (full === undefined || full === null) {
            full = 0
        }

        if (workerName === null || workerName === undefined) {
            workerName = ""
        }

        if (personalization === null || personalization === undefined) {
            personalization = ""
        }

        if (includeImage === 0) {
            includeImage = 0;
        } else {
            includeImage = 1;
        }

        var info = {
            fromDate: fromDate,
            toDate: toDate,
            status: status,
            country: country,
            customer: customer,
            orderNo: orderNo,
            woStatus: woStatus,
            changed: changed,
            isFull: full,
            pcode: pcode,
            shipCode: shipCode,
            workerName: workerName,
            personalization: personalization,
            pageSize: pageSize,
            page: page,
            dataType: DATA_TYPE_DESIGN,
            sortBy: 'orderDate',
            includeImage: includeImage,
            sku: sku,
            pcode: pcode,
            severity: onlyUrgent,
            fromDeadlineDate: fromDeadlineDate,
            donMua: donMua,
            hanGiaoMua: hanGiaoMua
        };
        // console.log("Search info", info)
        return info;
    }

    retrieveShipPackagesBy(fromDate, toDate, shipCode) {
        let info = {
            fromDate: fromDate,
            toDate: toDate,
            shipCode: shipCode
        };

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findShipPackagesBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveShippedAndReceivedPackagesBy(fromDate, toDate, shipCode) {
        let info = {
            fromDate: fromDate,
            toDate: toDate,
            shipCode: shipCode
        };

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findShippedAndReceivedPackagesBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrderErrorsBy(fromDate, toDate, woNo, errorCodes, errorOnly) {
        let info = {
            fromDate: fromDate,
            toDate: toDate,
            errorCodes: errorCodes,
            woNo: woNo,
            onlyError: errorOnly
        };

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findWorkOrderErrorsBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportWorkOrderErrors(fromDate, toDate, woNo, errorCodes, errorOnly) {
        let info = {
            fromDate: fromDate,
            toDate: toDate,
            errorCodes: errorCodes,
            woNo: woNo,
            onlyError: errorOnly
        };

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportWorkOrderErrorsBy`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveWorkOrdersBy(fromDate, toDate, status, country, customer, orderNo, woStatus, changed, isFull, pcode, shipCode, workerName, personalization, pageSize, page) {
        let info = this.initializeSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus, changed, isFull, pcode, shipCode, workerName, personalization, pageSize, page);
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchWorkOrders(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findWO`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    testMsg() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/testMsg`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchMaterialWorkOrderHistory(workOrderId) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/material-workorder-history/${workOrderId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchUnassignedWorkOrders(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findUnassignedWO`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    findWOByExportInfoAndStatus(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findWOByExportInfoAndStatus`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveCkFilesBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findCkFilesBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchCkFiles(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findCkFiles`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    searchWorkOrdersBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/findBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countWorkOrdersBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countBy`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    saveSimplePlan(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/saveSimplePlan`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    getLatestSimplePlan() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/lastSimplePlan`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    findWorkOrderList(info) {
        const token = sessionStorage.getItem('token');
        console.log(info);
        return axios.post(`${WORKORDERS_API_URL}/findWorkOrderList`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    finKcsWorkOrderList(info) {
        const token = sessionStorage.getItem('token');
        console.log(info);
        return axios.post(`${WORKORDERS_API_URL}/finKcsWorkOrderList`, info,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveChangedWorkOrders() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findChangedWorkOrders`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    completeChangedWorkOrders(id) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/completeChangedWorkOrders/${id}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    reportExcel(fromDate, toDate, status, country, customer, orderNo, woStatus) {
        let info = this.initializeSearchInfo(fromDate, toDate, status, country, customer, orderNo, woStatus);
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/reportExcel`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    getExportedInfoBy(selectedItems, dataType) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/getExportedInfoBy`, { workOrderIds: selectedItems, dataType: dataType },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    getDesignerExportedInfo(selectedItems, dataType) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/getExportedInfo`, { workOrderIds: selectedItems, dataType: dataType },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportExcel(selectedItems, filename, exportInfoId, oldExportedIds) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportShippingWorkOrders`, { workOrderIds: selectedItems, filename: filename, exportInfoId: exportInfoId, oldExportedIds: oldExportedIds },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportExcelByWorker(selectedItems, filename) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportWorkOrdersByWorker`, { workOrderIds: selectedItems, filename: filename },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportExcelByDesigner(selectedItems, filename, exportInfoId, oldExportedIds, dataType) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportWorkOrdersByDesigner`, { workOrderIds: selectedItems, filename: filename, exportInfoId: exportInfoId, oldExportedIds: oldExportedIds, dataType: dataType },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportExcelForShipping(selectedItems, filename, exportInfoId, oldExportedIds) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportShippingWorkOrders`, { workOrderIds: selectedItems, filename: filename, exportInfoId: exportInfoId, oldExportedIds: oldExportedIds },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportExcelForCk(selectedItems, filename, exportInfoId, oldExportedIds, dataType) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportWorkOrdersForCk`, { workOrderIds: selectedItems, filename: filename, exportInfoId: exportInfoId, oldExportedIds: oldExportedIds, dataType: dataType },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportPackages(shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportWorkOrdersByPackage`, shipCode,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    receivePackages(shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/receiveShippingOfWorkOrders`, shipCode,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    exportProduction(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/markForProduction`, selectedItems,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeToExportCatKhac(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/exportCk`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    checkAlreadyCKByIds(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/checkAlreadyCKByIds`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    completeCatKhac(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/completeCk`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    completeCatKhacByWorkOrder(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/completeCkByWorkOrder`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countUnassignedBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countUnassignedBy`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    getUnassignedBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/getUnassignedBy`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeWorkOrderStatus(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeStatusOfWorkOrders`, selectedItems,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    addNote(addingNote) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/notes`, addingNote,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    addDonMua(donmua) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/donmua`, donmua,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    markForWorker(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/markForWorker`, selectedItems,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    assignWorker(selectedItems, workerId, assignOnly) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/asignWorker`, {
            workOrderIds: selectedItems,
            workerId: workerId,
            assignOnly: assignOnly
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    assignWorkers(selectedItems, workerIds, assignOnly) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/asignWorkers`, {
            workOrderIds: selectedItems,
            workerIds: workerIds,
            assignOnly: assignOnly
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    chotWorker(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/chotWorker`, {
            workOrderIds: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    resolveIncidents(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/resolveIncident`, {
            workOrderIds: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    toBong(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/toBong`, {
            workOrderIds: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    toGhiThiep(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/toGhiThiep`, {
            workOrderIds: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fillGhiThiep(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/fillGhiThiep`, {
            workOrderIds: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    planWorkers(selectedItems, workerId) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/planWorkers`, {
            workOrderIds: selectedItems,
            workerId: workerId,
            planOnly: 1
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    resetPlan() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/resetPlan`,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    applyPlan() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/applyPlan`,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeToCatKhac(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeToCatKhac`, {
            workOrderIds: selectedItems,
            workerId: 0
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeToHoanThanh(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeToHoanThanh`, {
            ids: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            alert(error);
            return error;
        });
    }

    changeToDaSx(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeToDaSx`, {
            ids: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeToKiemTra(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeToKiemTra`, {
            workOrderIds: selectedItems,
            workerId: 0
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }


    changeToReady(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeToReady`, {
            workOrderIds: selectedItems
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    printTails(selectedItems, filename, exportInfoId, oldExportedIds, dataType) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/printTails`, { workOrderIds: selectedItems, filename: filename, exportInfoId: exportInfoId, oldExportedIds: oldExportedIds, dataType: dataType },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    reprintTails(selectedItems, filename) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/reprintTails`, { workOrderIds: selectedItems, filename: filename },
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeSemi(selectedItems, semi) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/changeSemi`, {
            workOrderIds: selectedItems,
            semi: semi
        },
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeDesigners(selectedItems, designer) {
        const token = sessionStorage.getItem('token');
        let changeRequest = {
            workOrderIds: selectedItems,
            designer: designer
        };

        return axios.post(`${WORKORDERS_API_URL}/changeDesignerOfWorkOrders`, changeRequest,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    checkAlreadyExportedByIds(selectedItems, designer) {
        const token = sessionStorage.getItem('token');
        let changeRequest = {
            workOrderIds: selectedItems,
            designer: designer
        };

        return axios.post(`${WORKORDERS_API_URL}/checkAlreadyExportedByIds`, changeRequest,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeShipping(selectedItems, shipInfo) {
        const token = sessionStorage.getItem('token');
        let changeRequest = {
            workOrderIds: selectedItems,
            shipInfo: shipInfo
        };

        return axios.post(`${WORKORDERS_API_URL}/changeShippingOfWorkOrders`, changeRequest,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateShipping(shipCode, newShipInfo) {
        const token = sessionStorage.getItem('token');
        let changeRequest = {
            oldValue: shipCode,
            newValue: newShipInfo
        };

        return axios.post(`${WORKORDERS_API_URL}/updateShipCodeOfWorkOrders`, changeRequest,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countShipWorkOrders(status) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/countShipWorkOrders/${status}`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    countShipVnPackage(){
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/countShipVnPackage`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    countNonShipUsWo(){
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/countNonShipUs`, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    retrieveWorkOrdersByPackage(shipCode) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findByPackage/${shipCode}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    changeToShipFromUS(workOrderId) {
        const token = sessionStorage.getItem('token');
        let changeRequest = {
            workOrderId: workOrderId
        };

        return axios.post(`${WORKORDERS_API_URL}/changeToShipFromUS`, changeRequest,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    downloadExportCKBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/downloadExportCKBy`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    downloadForCk(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/downloadForCKBy`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` },
                responseType: 'blob'
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    countByDeadline(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countByOverDeadline`, info, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    countByReprintTail(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countByReprintTail`, info, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    countBySuco(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/countBySuco`, info, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    fetchWorkerPlans() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/workerPlans`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchNextWorkerPlans() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/nextWorkerPlans`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    fetchRoundInfoBy(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/getRoundInfoBy`, info, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    fetchTodayRounds() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/getTodayRounds`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    endActiveRound(roundId) {
        const token = sessionStorage.getItem('token');
        return axios.put(`${WORKORDERS_API_URL}/round`, { id: roundId },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateXi(selectedItems) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateXi`, selectedItems,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateHanSx(info) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateHanSx`, info,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    updateDaLen(updateInfo) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/updateDaLen`, updateInfo,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveDHL() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/dhl`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        });
    }

    retrieveDHLDetailsBy(nhom, status, shipTo) {
        let info = {
            nhom,
            status,
            shipTo
        }

        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/dhlDetails`, info, { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error)
            return error;
        });
    }

    postShipInfo(workOrderId, shipInfo) {
        const token = sessionStorage.getItem('token');

        return axios.post(`${WORKORDERS_API_URL}/shipInfo/${workOrderId}`, shipInfo,
            {
                headers: { 'Authorization': `Bearer ${token}` }
            }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveImage(workOrderNo) {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/sid?workOrderNo=${workOrderNo}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        });
    }

    fetchQualityReports(page, pageSize, fromDate, toDate, workOrderNo, pcode, tinhTrang, loaiSuCo) {
        const token = sessionStorage.getItem('token');
        return axios.post(`${WORKORDERS_API_URL}/qualityReports`, {
            page: page, pageSize: pageSize,
            fromDate: fromDate,
            toDate: toDate,
            workOrderNo: workOrderNo,
            pcode: pcode,
            tinhTrang: tinhTrang,
            loaiSuCo: loaiSuCo
        },
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            console.log(error);
            return [];
        });
    }

    exportQualityReports(fromDate, toDate, workOrderNo, pcode, tinhTrang, loaiSuCo) {
        const token = sessionStorage.getItem('token');       
        return axios.post(`${WORKORDERS_API_URL}/exportQualityReports`, {
            fromDate: fromDate,
            toDate: toDate,
            workOrderNo: workOrderNo,
            pcode: pcode,
            tinhTrang: tinhTrang,
            loaiSuCo: loaiSuCo
        },
        { 
            headers: { 'Authorization': `Bearer ${token}` },
            responseType: 'blob' 
        }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    deleteQualityReport(qualityReportId) {
        const token = sessionStorage.getItem('token');
        return axios.delete(`${WORKORDERS_API_URL}/qualityReports/${qualityReportId}`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

    retrieveShipCodes() {
        const token = sessionStorage.getItem('token');
        return axios.get(`${WORKORDERS_API_URL}/findShipPackages`,
            { headers: { 'Authorization': `Bearer ${token}` } }
        ).then(response => {
            return response.data;
        }).catch(error => {
            return error;
        });
    }

}

export default new WorkOrderDataService()